module.exports = __webpack_public_path__ + "media/ai-avatar.c8a46d01.mp4";